const XPD = ({ ...props }) => (
  <svg
    version="1.1"
    viewBox="0 0 2048 2048"
    width="1280"
    height="1280"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      transform="translate(969)"
      d="m0 0h112l58 6 46 6 35 6 50 11 41 11 35 11 35 12 40 16 25 11 28 13 24 12 22 12 28 16 41 26 16 11 17 12 19 14 28 22 13 11 14 12 10 9 8 7 12 11 8 8 2 1v2l4 2 20 20 7 8 11 11 7 8 13 15 9 10 9 11 13 16 9 12 10 13 24 34 10 15 12 19 13 21 13 23 13 24 19 38 14 31 14 35 10 27 12 36 10 34 12 48 9 45 6 39 5 43 4 41v109l-5 53-5 41-7 43-9 43-9 36-12 40-12 36-12 32-12 29-15 33-9 19-10 19-15 28-15 25-10 16-11 17-12 18-13 18-10 14-14 18-12 15-9 11-12 14-10 11-7 8-12 13-7 7-7 8-18 18-8 7-10 10-8 7-10 9-11 9-11 10-14 11-16 13-19 14-18 13-19 13-17 11-19 12-22 13-25 14-29 15-33 16-37 16-37 14-26 9-28 9-35 10-38 9-45 9-40 6-59 7-23 2h-112l-58-6-39-5-41-7-38-8-36-9-35-10-36-12-38-14-24-10-27-12-25-12-28-14-23-13-21-12-19-12-25-16-20-14-17-12-17-13-14-11-16-13-14-12-15-13-13-12-15-14-10-10-6-5-7-8-13-13-7-8-8-8-7-8-11-13-9-10-11-14-12-15-12-16-13-18-12-17-15-23-14-22-10-17-13-23-12-22-11-23-12-25-18-43-15-40-13-40-11-39-10-43-7-36-7-45-5-46-3-33v-112l7-69 7-48 10-50 9-37 9-32 8-26 14-40 14-35 13-30 13-28 10-19 12-23 9-15 6-11 11-18 22-34 24-34 12-16 13-16 9-12 9-10 9-11 11-12 7-8 12-13 11-11 1-2h2l2-4 12-12 8-7 12-12 8-7 12-11 11-9 10-9 14-11 16-13 16-12 20-14 18-13 16-10 20-13 27-16 25-14 41-21 24-11 38-16 29-11 44-15 49-14 43-10 42-8 40-6 44-5z"
      fill="#F37441"
    />
    <path
      transform="translate(1345,368)"
      d="m0 0h10l21 2 20 4 19 6 17 7 15 8 17 11 10 9 11 10 7 8 9 11 10 15 10 19 7 19 4 15 4 23 1 10v17l-3 25-6 23-8 21-12 22-13 18-12 15-9 12-11 14-9 12-14 18-12 16-11 14-13 17-11 14-21 27-15 20 260 1 6 5 3 7 6 137 4 99 2 49v30l-3 6-12 17-14 18-10 13-8 11-10 13-13 17-12 16-13 17-9 12-10 13-15 20-10 13-21 28-14 18-14 19-14 18-27 36-13 17-12 16-10 13-16 21-12 16-16 21-21 28-13 17-14 18-16 22-7 7h-309l-7-4-4-6-1-5v-312l3-6h2l2-4 11-14 10-13 8-11 10-13 15-20 14-18 8-11 1-1-9 2-9 3-10 13-16 21-12 16-16 21-12 16-16 21-12 16-16 21-14 19-7 9-13 17-12 16-10 13-16 21-14 19-14 18-14 19-10 13-13 17-8 11-13 17-7 6-2 1-305-1-6-3-6-7-1-5-1-66v-172l1-75 8-10 13-17 21-28 16-21 12-16 10-13 21-28 16-21 33-44 13-17 15-20 29-38 30-40 10-13 24-32 10-13 9-12 16-21 9-12 16-21 33-44 10-13 5-5 2-1 154-1 7-8 13-17 14-18 20-26 14-18 13-17 14-18 13-17 14-18 13-17 14-18 13-17 14-18 10-13 14-18 30-39 13-17 14-18 9-11 9-10 9-9 14-11 18-12 23-11 19-6 24-5z"
      fill="#FEFDFD"
    />
    <path
      transform="translate(1637,1178)"
      d="m0 0h2l2 10h-2l-2 7-3 1-2 6h-2l-2 7-1 2h-2l-2 4-2 7-5 6-2 5h-2v3l2 1-2 3h3v3l5-2 4-2 2-5h2l1-2 2 8-4 3-3 1 3 1-5 2-1 9-2 4 4 1 1-2h8l1-2 5 1 1-6 5-1 3 2 1-2 6-2 1 2 2-1 3-4 6 5-1-3h2l1-3 6 4-1 2 4-2 3-3 5-2 7-1 4 1 2 3 5 2 9 1v-2l5-2h7l3-2h4l1 4-4 1 2 5-2 4 9 1 9 2 5-1h8l4-1 2-6 3-5 2-5 5-8h2l-2 12v9l-2 7h2l2-1 1 3 3-1 2-4 9-12 4-5 5-2 2-5 6-5 3-6h2v2l8-3 12-3 7-1v2h2l8 13 3 5v6l9 7v3h3v2l9-2 1-5-2-1 3-5-2-1 1-1 10-1 6 2 2 5v3h2l1-4 4-1v2h2v3l8 4 1 4h5l5 6 2 3 2-9 4-5 5-2 6-1 2-6h7l3-3 2-3 2 1v-7l1-2 3 1v2h2v2l2 1 2 2 4 1 9-1-1-4-2-1 2-3 7 1v2l6-3h2v-2l-5 1v-2l-2-1 4-4h3l1-4 1-3h2l1-3 2 1v5l5 1v-2l3-3 4-5 1 5 4-2 1 4 1 1-1 9-2 8 2-1 1 2-1 18-2 7h-2v12l1 2-2 2-2 3v15l-10 34-12 36-11 30-14 34-15 33-9 19-10 19-15 28-15 25-10 16-11 17-12 18-13 18-10 14-14 18-12 15-9 11-12 14-10 11-7 8-12 13-7 7-7 8-18 18-8 7-10 10-8 7-10 9-11 9-11 10-14 11-16 13-19 14-18 13-19 13-17 11-19 12-22 13-25 14-29 15-33 16-37 16-37 14-26 9-28 9-35 10-38 9-45 9-40 6-59 7-23 2h-112l-58-6-39-5-41-7-38-8-36-9-35-10-36-12-38-14-24-10-27-12-25-12-28-14-23-13-21-12-19-12-25-16-20-14-17-12-17-13-14-11-16-13-14-12-15-13-13-12-15-14-10-10-6-5-7-8-13-13-7-8-8-8-7-8-11-13-9-10-11-14-12-15-12-16-13-18-12-17-15-23-14-22-10-17-13-23-12-22-11-23-12-25-18-43-15-40-13-40-11-39-4-16v-10l3-3 1 2 4 1 1 10 2 1 2 11v3l7 1 1 5h1v-3l1-2h7l1 5-1 2h3v2h3v3h2l1 2 1-8-4-2v-8l3-3 2-1v-4h3v-2l-2-1h2v-5l6-4 4-1h4l7 6 3-1v2l4-1v-3l-9 1-2-4 8-1 2-4 4 2 1 4 2 4 4-1 4 1 1-3 1 3 3-11 3-1 2 1v2h2v-2h10v-5l1 2 7-2 1-3 4-1 6 7-2 2 2 2h9l1-2 2 4 4 2v-2l5 1 1 3 3 1-1-3h6v-2l3-3 2-1v4h6l4-1 5 5-1 6 4 1v2l3 1v3l4 2h2l2-4 5 1v2h3l3 4 4-1 5-9 1-5 4-3h3l1-5 2-2h19l13-4h3l1-3 6 2 2-2h4l2 3 3-1-1-4 2 1v2h4 6l3 3-1 4 3 1-1 5-2 1 1 3-5-1v2h6l1-3 3 2 1-3 2 3 3-1 4 6 3 1 4-1v-2l4 1v-2l2-1 2-4 1 4-1 2 4 1v-2l4-2v3l2 1v2l4-2 3-2-1-3h2l1-3 4 2v3h4v-2h2l-1 3-4 1v2l4-2 2 1 3-3 6-2v-2h3l1-2v2h2l-1-5-1-3h3l2-4 3-1 2 1 1-2h4l1-3v4l-4 6-2 1 1 3-1 1h3v-3h2l2-4 1 5-1 1h5v-2l10-6 2 1v3l1 6-9 11-6 8-1 75v172l1 66 2 7 7 6 3 1 305 1 6-4 7-8 8-11 14-19 11-14 12-16 16-21 15-20 16-21 10-13 30-40 13-17 12-16 29-38 12-16 16-21 12-16 16-21 12-16 7-9 5-5 13-4 4 1-8 10-14 19-14 18-21 28-10 13-7 9-6 8h-2l-2 6v312l2 7 5 5 4 2h309l8-8 7-10 14-19 14-18 6-8 10-13 9-12 16-21 9-12 16-21 14-19 11-14 15-20 13-17 12-16 29-38 9-12 10-13 27-36 13-17 12-16 10-13 16-21 9-12 10-13 18-24 26-34 10-14 4-6z"
      fill="#DC2A5E"
    />
    <path
      transform="translate(1637,1178)"
      d="m0 0h2l2 10h-2l-2 7-3 1-2 6h-2l-2 7-1 2h-2l-2 4-2 7-5 6-2 5h-2v3l2 1-2 3h3v3l5-2 4-2 2-5h2l1-2 2 8-4 3-3 1 3 1-5 2-1 9-2 4 4 1 1-2h8l1-2 5 1 1-6 5-1 3 2 1-2 6-2 1 2 2-1 3-4 6 5-1-3h2l1-3 6 4-1 2 4-2 3-3 5-2 7-1 4 1 2 3 5 2 9 1v-2l5-2h7l3-2h4l1 4-4 1 2 5-2 4 9 1 9 2 5-1h8l4-1 2-6 3-5 2-5 5-8h2l-2 12v9l-2 7h2l2-1 1 3 3-1 2-4 9-12 4-5 5-2 2-5 6-5 3-6h2v2l8-3 12-3 7-1v2h2l8 13 3 5v6l9 7v3h3v2l9-2 1-5-2-1 3-5-2-1 1-1 10-1 6 2 2 5v3h2l1-4 4-1v2h2v3l8 4 1 4h5l5 6 2 3 2-9 4-5 5-2 6-1 2-6h7l3-3 2-3 2 1v-7l1-2 3 1v2h2v2l2 1 2 2 4 1 9-1-1-4-2-1 2-3 7 1v2l6-3h2v-2l-5 1v-2l-2-1 4-4h3l1-4 1-3h2l1-3 2 1v5l5 1v-2l3-3 4-5 1 5 4-2 1 4 1 1-1 9-2 8 2-1 1 2-1 18-2 7h-2v12l1 2-2 2-2 3v15l-10 34-12 36-11 30-14 34-15 33-9 19-10 19-15 28-15 25-10 16-11 17-3 3-1-5v-3l3-4h2v-2l3-1v-6l-2-2-1 4h-2l-1 4-2-1-1 2-2-1-1 5h-2v2l-6 4-5 5v2l-7 5h-2v2l-4 1v3l-5 1-1 4-6 3h-3v2l-5 1-2 4-1 3-6 2-4 1-2-6-1-6h-5l-1 7-8 1-2-1-1 2-2-2-1 2-5-1v-2h-2l-1 3h-6l-1 3h-7v2h-5l-3 5-5-1-1 3-4-1-3 2h-3l-1 2-1-2-5-2v-2l-2-1h-1l-2 4-6-1v-2l-6 1v-4h2l1-5 4 1-1-7 2-6-4 2-2 3h-5l2-1-1-3 4-3-3-3 1-4h2l-1-3 3-1-1-2 1-3 3-1 3-7h-9l-4-1 1-5-5 1-1 2-10 1-11 6-5 5-8 4-7 2-5 2h-7l-9 3h-3v2l-10 4-9 1-11-2-1-2 1-2h-2l-1-2h-21l-9 2-1 3-15 8-1 2-2-1 3-5-6 3-6 5-15 9-4 2-4 5-13 5-9 1-10-1-11-4 1-2-12-1-1 3h-4v2l-15 2-10 3-8 3-24 10-7 3h-3l-1-1-5 3h-3l1 3-7 2-5 2-2-8h-3-5l-1 1-18 3v-2l-10 1v-2l-5 1-1 2-2-1-1 5h-6l-4-2v-2h2v-4l-2-1-1 3-2 1v3h-2l-1 4h-2l-1 3-4 2h-3v-2l-2-1 1-3-5 3-1 2h-3v2l-7 3-7 10-3 2-1 3-10 2-6-1-1 1-11 1-3 1-1-2-1 1h-9v1h-5l-2-1-9 1-4-1v2l-7-1-4 1-7-1-1 2h-2v-2h-7l-5 2-9 1-3-1-8 2v-2l-3 2-7-1h-4-12l-5 1-1-2-10 1h-30l-7-1-2 1v-2l-8 2v-2l-6 2-2 1-2-1v-2l-4 2-7-1-4 1-5-1h-4l-7 1-5-1-4 1-1-1-10 1h-5l-1-1-10 2-8-2-2-1-1 3-3-1h-12-3-5l-2-2-11-1v-2h-3v-2h-2v2h-2v-2l-4-1-6-6 2-4 3-1v2l10-1 2-1 1-2-10-2v-2h311l8-8 7-10 14-19 14-18 6-8 10-13 9-12 16-21 9-12 16-21 14-19 11-14 15-20 13-17 12-16 29-38 9-12 10-13 27-36 13-17 12-16 10-13 16-21 9-12 10-13 18-24 26-34 10-14 4-6z"
      fill="#E44455"
    />
    <path
      transform="translate(1019,1240)"
      d="m0 0 4 1-8 10-14 19-14 18-21 28-10 13-7 9-6 8h-2l-2 6-1 311h-1l-1-13v-11l-1-9v-22l-1-21-2 14h-2l2 6v4h-2v7h-2l1 4-1 4 1 4-3 4v3l-3 4h-2l-1 3h-4l-1-4h2v-2h-3l1-8-5-1-1-3h2v-2h-2l-1-2h-3l-3 3-2-2v-7l-4-3-4-1v2l-6 1-4 4h-2v2h-3l-1 2-2-1v2h-2l-2 4-4 4-7 1v7l-1 1h-18l-1 6h-5l-1-4-3 5-2-1-5-4v2l-14 2-7 2v-2l-4 2-3 3-6 3-3-1v-2h-2l1 3h-3v-2l-4 1v2l-4 2h-3v-2l-4 1v2h-2v2l-11 2v-2h-2v-2l-8 1h-4l-1 2-5-5 2-1v-2l-5 5-2 1v-2l-7-1 2-4v-1l1-4h-2l-2 4-1-2h-2l-1-7-3 1v5l-3 2-4-1-3-3 1-6h-11l-1 3h-2l-1 3h-4v-4l-3-3-1 2h-4l-2-3-4 1-3 3-1-2h-6l-2-1v-4h-6l-3 1v4l-9-1 1-3 3 1 2-2-5-3-2 3-15-2-4-1v2h-16v-2h-2l-1 2h-1-2v-2h-2v2h-8l-1-2-2 3-4-2-5-1v2l-4-1h-6l-4 1h-8-4l-4-1-1 2-4-1h-4l-5 2v-2h-7v2h-2v-2l-6-1-5 1v-2l-5 2h-3v-2l-5 2-10-1v-2l-5 1-1 3-1-3-9 2-6 1-4 2-4-1-5 1-1 2-2-6-5 3h-6l-5 2-7 1-2 1v-3l-6 1-4-1h-3v-2h-3l-1-2-7-1-5-5v-4l-2-2-2-4h-3v2h-2v-2h-2l-1 2-1-5-3 2h2v2h-2l-1 2-2-1v-2l-2-1v-2l-2-4h-4v2l-5-1-1-5h-4v2l-3-1-5-4v2l-3 2-2 6-4 2 1 2 2 1-4 4v5l4 1-1 3v-2h-2l1 3-1 6-7 3v5l4 1v4h-2v3h-4l-1-2h-3l1 6-1 3h-2l-1 4 1 3-3 3-2-3v-2l-4 2v4l-3 1-1 2-2-2v-3l-2-1-4-1-2 1-1 3h-8l-2 1v-3h-2l-2-6v3l-2 4-3 2-2-6-4-1-4 3-3-2v-3h-4l-3 1v-2l-3-1v8l-1 5 4 5 2-2 2 4 2 1v2l4 2 3 7 3 1h3l3 5 4 8 2 2h3l4 8 4 2h2v2h2l2 5 1 6h-3v2l5-2 4 3-1 2v1l1 4 6 2v3l-7-3-1 2 1 1 1 4 5-1v2h2l1 5 5 4 2 1v3l2 1h-2v3h2l3 3-1 5-1 1 3 1 1 4 2 1h-3l-10-9-16-15-10-10-6-5-7-8-13-13-7-8-8-8-7-8-11-13-9-10-11-14-12-15-12-16-13-18-12-17-15-23-14-22-10-17-13-23-12-22-11-23-12-25-18-43-15-40-13-40-11-39-4-16v-10l3-3 1 2 4 1 1 10 2 1 2 11v3l7 1 1 5h1v-3l1-2h7l1 5-1 2h3v2h3v3h2l1 2 1-8-4-2v-8l3-3 2-1v-4h3v-2l-2-1h2v-5l6-4 4-1h4l7 6 3-1v2l4-1v-3l-9 1-2-4 8-1 2-4 4 2 1 4 2 4 4-1 4 1 1-3 1 3 3-11 3-1 2 1v2h2v-2h10v-5l1 2 7-2 1-3 4-1 6 7-2 2 2 2h9l1-2 2 4 4 2v-2l5 1 1 3 3 1-1-3h6v-2l3-3 2-1v4h6l4-1 5 5-1 6 4 1v2l3 1v3l4 2h2l2-4 5 1v2h3l3 4 4-1 5-9 1-5 4-3h3l1-5 2-2h19l13-4h3l1-3 6 2 2-2h4l2 3 3-1-1-4 2 1v2h4 6l3 3-1 4 3 1-1 5-2 1 1 3-5-1v2h6l1-3 3 2 1-3 2 3 3-1 4 6 3 1 4-1v-2l4 1v-2l2-1 2-4 1 4-1 2 4 1v-2l4-2v3l2 1v2l4-2 3-2-1-3h2l1-3 4 2v3h4v-2h2l-1 3-4 1v2l4-2 2 1 3-3 6-2v-2h3l1-2v2h2l-1-5-1-3h3l2-4 3-1 2 1 1-2h4l1-3v4l-4 6-2 1 1 3-1 1h3v-3h2l2-4 1 5-1 1h5v-2l10-6 2 1v3l1 6-9 11-6 8-1 75v172l1 66 2 7 7 6 3 1 305 1 6-4 7-8 8-11 14-19 11-14 12-16 16-21 15-20 16-21 10-13 30-40 13-17 12-16 29-38 12-16 16-21 12-16 16-21 12-16 7-9 5-5z"
      fill="#E44455"
    />
    <path
      transform="translate(1332,882)"
      d="m0 0h247l-4 7-10 14-14 19-13 18-14 19-11 15-10 14-12 16-13 18-14 19-13 18-11 15-8 11-11 15-14 19-13 18-28 38-16 22-13 18-14 19-13 18-14 19-11 15-10 14-13 17-10 14-7 9-10 1h-222l-26-1 2-5 4-5 29-38 12-16 10-13 14-19 10-13 7-9 8-11 10-13 12-16 29-38 14-19 10-13 9-12 10-13 15-20 13-17 12-16 14-18 14-19 13-17 10-13 7-9 8-11 10-13 12-16 14-18z"
      fill="#F27341"
    />
    <path
      transform="translate(1595,913)"
      d="m0 0 2 1 5 124 2 53 3 76-4 8-10 13-16 21-14 19-10 13-9 12-10 13-21 28-10 13-12 16-16 21-12 16-16 21-27 36-10 13-33 44-10 13-15 20-13 17-12 16-13 17-24 32-20 26-2 1v-255l4-7 10-13 24-33 13-18 14-19 13-18 12-16 10-14 28-38 10-14 6-8 11-15 14-19 26-36 12-16 16-22 14-19 13-18 9-12 10-14 14-19 13-18 11-15 13-18z"
      fill="#E44455"
    />
    <path
      transform="translate(1345,399)"
      d="m0 0h11l20 2 21 5 25 10 10 6-2 4-8 11-9 12-14 18-13 17-14 18-10 13-14 18-40 52-13 17-12 15-9 12-10 13-14 18-10 13-13 17-14 18-26 34-12 15-9 12-14 18-20 26-13 17-12 15-9 12-10 13-14 18-10 13-12 15-6-2-16-8-25-10-19-5-21-3h-32l-20 3-20 4 4-6 8-10 9-12 12-15 9-12 20-26 12-15 8-11 11-14 8-11 12-15 12-16 11-14 7-9 10-13 13-17 11-14 16-21 10-13 13-17 14-18 26-34 8-10 10-13 14-18 26-34 14-18 10-13 14-15 11-10 17-11 21-10 15-5 17-4z"
      fill="#F37441"
    />
    <path
      transform="translate(1457,442)"
      d="m0 0 7 6 9 10 10 15 10 19 7 21 5 25v30l-4 22-5 17-6 14-9 16-12 17-11 14-13 17-14 18-13 17-14 18-10 13-14 18-40 52-13 17-9 11-10 13-14 18-20 26-12 16-11 14-12 16-8 10-10 13-11 14-12 16-14 18-20 26-22 28-3 2-2-30-4-21-5-17-8-19-8-15-11-16-12-14-12-12 2-4 11-14 13-17 8-10 12-16 11-14 13-17 11-14 16-21 10-13 13-17 14-18 8-10 12-16 11-14 16-21 12-15 12-16 10-13 13-17 14-18 8-10 8-11 12-15 15-20 12-15 15-20 8-10 10-13 14-18 12-16 10-13 11-14z"
      fill="#F37441"
    />
    <path
      transform="translate(854,808)"
      d="m0 0h66l-2 4-10 14-14 18-10 13-13 17-12 15-15 20-22 28-13 16-13 20-12 23-7 19-5 22-2 16v29l4 24 5 17 6 16 8 16 1 5-4 6-8 11-26 36-14 19-13 18-12 16-1 1-12 1h-243l-4-2 14-18 10-13 8-11 13-17 18-24 13-17 12-16 16-21 12-16 16-21 9-12 16-21 18-24 13-17 24-32 14-18 14-19 29-38 21-28 10-13 36-48 10-13z"
      fill="#F27341"
    />
    <path
      transform="translate(981,1371)"
      d="m0 0h255v277l-50 1h-176l-40-1-1-1v-275z"
      fill="#E44455"
    />
    <path
      transform="translate(441,1298)"
      d="m0 0h266l1 1v276l-2 1h-81l-184-1z"
      fill="#E44455"
    />
    <path
      transform="translate(942,917)"
      d="m0 0h15l17 2 17 4 24 9 23 12 16 12 13 12 11 13 11 17 8 17 5 15 3 12 2 13 1 18-2 22-5 21-5 14-9 17-7 10-9 12-10 11-11 9-10 7-18 10-18 7-21 5-15 2h-22l-19-3-20-6-20-8-15-8-17-12-13-12-9-10-14-21-9-19-5-15-4-19-1-9v-24l3-20 6-20 6-13 7-13 8-11 8-10 12-12 10-9 13-8 15-8 19-7 18-4z"
      fill="#F27341"
    />
    <path
      transform="translate(813,1185)"
      d="m0 0 12 12 8 7 13 10 18 11 19 9 22 8 20 5 22 3 13 1-2 5-11 14-12 16-10 13-9 12-16 21-14 19-14 18-14 19-10 13-12 16-10 13-21 28-10 13-15 20-13 17-9 12-10 13-8 10h-1v-254l3-6 14-19 13-18 11-15 26-36z"
      fill="#E44455"
    />
    <path
      transform="translate(1595,913)"
      d="m0 0 2 1 5 124 2 53 3 76-4 8-10 13-16 21-14 19h-3v-3l1-4-2-1-1 4h-3l-1 5-2-2v3h-3l-4 4h-2v2l-4 2-3-4 2-1 1-3h3v-2l-2-1h3l-1-3 1-2h-3l-2 4-4 4-2-3-6 2 5-15 1-4-1-2-6-1v2h-2l-1 3h-8l-2 5h-2l4-10-5 3-3 4-6 2-11 2-9 3h-3l-1 3-14 6-2-1v-9l1-1-2-1v2h-6l-6 3h-5v2l-6 1-1 2-5-3v-2l5 1v-3h-2l-1-2-10 3-7 2v2l-6 5-5 1v2l-6 4-5 5-8 6-5 6-12 9 2-4 11-16 1-5 2-5 2-3h2l1-4 2-1 3-8-2-1-1 4h-4v-2h2v-2l-3-1 1-2h2l-1-4 1-1v-5h4v-7l3-1 1-2h-4v2l-4 2-1 2h-2l2-4 13-18 22-30 14-19 26-36 12-16 16-22 14-19 13-18 9-12 10-14 14-19 13-18 11-15 13-18z"
      fill="#F27341"
    />
    <path
      transform="translate(1466,1936)"
      d="m0 0 2 2-2 2-1 2-16 8-6 2-12 5-9 3-1 2-7 3-9 2h-3l-1 3-13 5-6 1-5 3-7 2-9 4-4 1-7 3-5 1-7 3-5 1-9 3-7 2-5 2-18 4-3 1-2-1v2l-14 3-12 3-6 1-15 3-5 2-9 1-13 2-6 3-16 2-3 2-23 1v2l-4 1h-8l-2-1-1 2-4-1-3 1-2 3v-3l-8 5-1 3-12 2-42 4h-112l-48-5-4-1v-5h3v-2h-8l-7-1-8-3-5-3-8-3-2-1-1 2-1-3h-7l-4-2-5 1-6-1-1-4-2-2-3-1-2 1v-2l-5-1-2 2-3-1-1-3-4 1h-3l-4-4v-2h-3l-2-2h-10l-2-2h-6l-8-4h-8l-4-3v-2h-2l-1 2-3-2 2-1-4-1-3 1-1-4-5 1-3-1-1-3v3l-3-1-1-2h-4l1 4-2 2-3-1-2-6v-2l-1-4 1-2h-2v-2l5 2 3 1 1-4 2-2 2 4 8 4v2h2l1-4 8 4-1-6h2v-2l-2-1 4-2v2l4 2 4-1 1 2 6 5v2h2l1-2 1 1 1-2 3 1 5-2h5v5 4l2 1 4-1-2-1-1-4 5-2 1 5 5-2v-2l-3-1h14l6-2 1 4-1 2 4-1 2-3 5 1-1 3h3l1 2h3l2-1v-2l-3-1 4-1 1 2 5-1 2 1 3-6h6l4-1 2 5 2 1 9-1 4-1 2-4 2 3v4l5-1 4-1 1 2 3-2h3 2v5h6l2 2 2 1h3l8 1 1-4h-3l1-5 1 2 6-2 8 5 7 1h7v2l2-1-2-2-4-1h2v-5h4v2l5-1 1-2 5-1h3v-3l3-1 4 5 2-4 3-1h8l-1-1v-6l5-1 1 2-1 3 1 2h-2l1 3 2-2 1-3-1-5 4-1 5 2 4-1 1-2 2 1-1 2 3 1v5l-3 2v2h6l1-6h4l3 6h2v-2h3v-2l5-4 2 1-1 4-1 2h-2v2l4-1 3 3 5 3 1-2 5-5 4 2-1 3 10-2 4 2 1 5 6-3 4 1 2 4h6l-2-6 4-1 1 3-1 2 3-1 4 4 6 1 1 7 3-1-3-5 2-4h2v2l3 1-1 3 7 1-3-5 4 1 3 1 1 7 5 1 1-2v2l9-2 5 1v-6l5-1h3l1 6 3-1 1-6 4 2-1 5 4 1v-3l3-1 4 5 3-6 1 4 3-1 1 1 2-9h1v6l6-1 4-2 2-4 2-1v2l2 1-3 3 4 2 2-5h9l6-2 5 1 2-5h3l1 2 2-4h7l4 1 1-4h-2l1-3 4 1v3h7l1-2h4v4l2-4 6-2h3l1-2 5-1 4-1-1-2h5v2h4l3-6 4 4-1-3h2l1-4 2 2 5-1 1-3 3-2h3v2h2l1-2h2l5-1 3 1v2h2v-3l4-1 3 1v3h4l3-5 10 1 4-3 12-3 2 1v-2h3l1-2 3 3h-3l2 1-1 5v1h3l1-2h3v2h-3l-1 3-3-1v2l-3 1-1 3h-6v4h3 4l4-1 1-4 7 1 3 2v-2l-4-1 2-6 3-1 1-2h2v-2h-2v-2l-6 1-1-3 1-4 2 1 1 3 4-1 2-4h2v3l2 1-1 4-2 3h2v2h2l-1 2-2-1 1 3 1 1h2v-2l7-2 5-3v-3h2v4h2l1-2 4-2 1-2 5-1 2-2 2 1 1-2 2-1v2l3-3h3l2-2 4-1 1-2 7-1z"
      fill="#D61B62"
    />
    <path
      transform="translate(1273,1200)"
      d="m0 0 6 1-4 10-5 1-1 5v3l-4-1-2 5-2 1h5v-2l10-3 2-1 2 1v-2h2v-5l-2-1h4l1-2 2 1 1-2h2v5l2 1 1 4-2 4-1 4 1 2-1 2-4 2v3l2 1h-2l1 3-3 2-3-2 2 4-2 5-2 1v2l3-3h2l1-5 2-2 1-2 3-1 6-8 1-2h2v2h2l2-5 2-2h4l-1 4h-2v5l4-1v-2l3 1v2h-2v2h-2l-3 9h2l2-7 3-1 1-4 2-1 1-4 3 1v2h-2l1 4-3 4-1 2-3 4-1 5-13 18-11 15-8 11-28 38-7 9-10 1h-222l-26-1 2-5 4-5 29-38 12-16 10-13 14-19 10-13 7-9 8-11 2-3 5-3 3-4 5 1-2 6h-3v6h-3v4h-2l-1 2-1 3v4l-4 7 2 1-1 3h-3l-1 4h2v-2l7-2 4-3 2 1-3 4-1 8h-2v2h-2v2h-2v3l-4 2 1 2-5 5-2 5 3 1v-2h2l1-4 4 1 2-2-2-1 4-6 3-1v2l-1 1 4-1 3-5 2-1 3-5h2v-2h2v-2l10-4 3-3 1-6h2v-2l7 1 3-2 3 3 9-6 3 1v2 3l-3 1v-2l-4 1-2 4-5-1 1 3 4-1 10-3 5 1 4-2v3h-2v3h-2v2h-2v2l-5 4h-2l-1 5v1 4l2-2 6 1v-2l7-1 1 2h-2v2h-2v2l-3 2 1 3 12-1 4-4v-4l2-3 5 1 4-2 4 4 8-1v2h5l1-2h5l1-4h3v-2h3l2-6 5-4 6-3 1-1 9-1 3-2 2-3 3-1 1-3h4v-2l5-1v-2h5v-2l5-4 3-3 5-3z"
      fill="#E44455"
    />
    <path
      transform="translate(533,1168)"
      d="m0 0h3l1 5-4 4-1 3h-3l-1 4-6 11-2 4h-2l1 6h-2l-1 4-2 4v3l2-3 3 3 1 5-5 5v4l-3 1-2 3h-2v4h-2v7l2 4 8 6h9l-1-3-3-1 4-3 2-7 7-5h2l1-6 8-2 3-6 4 1v-2h4v2l2 1-2 1-2 9 3 1-3 1v2l9-1 1 4-1 5h5l5 2h6l6 1 12 1 5-2v2l4-1 5-1v2h9l3 3 6-2 2 1v2h19l8-1 4-1 5 1-1 3-4 1 7 2 5 1 5-1 4 1 4-1 4 1 15-4h2v2h4v-2l5 1 4-4 1-2-3-1 1-2h3v-2l-3-1 3-1 1-3 1 3-1 3h2l2-4 1 5-3 6-9 12-1 1-12 1h-243l-4-2 14-18 10-13 8-11 13-17 18-24 11-14z"
      fill="#E44654"
    />
    <path
      transform="translate(1155,1598)"
      d="m0 0 1 2 3 1-2 7-1 2v4l2-5 4-1 5 1-1 3h3v-2l1-1-2-3 1-5h6l1 7 4-1 5 2 3 1-2 1-1 3h-3l4 1 2-1v2l12 1 1-2 7 1 2 1v4l3-2 1-2 2 4 6 3v2l-6 4-3 1-1 2-5 3-4 1h-12l-4 1v-2h-2v2l-5 1-2-2-7 2v-2l-8 3v-3l-4 2-8-1-3 2-8-2-5 2-2-1v-2h-2v2h-16-4-14l-4-1-6 1v-2l-4 1-3 1-4-1-3 1-4-1-6 1-1-2-4-1-1 3-4-1-5-1-1-3-2 1v3l-5-1-2-1-1 2-3 1-1-3-9 1-1-2-5 2-4 1v-5l-4-1-2 1-2-3-3-1-1 3-6-1-2-1 1-3h2l1-4-2-1-2-3 3-2h3l4-1 2 4 4-3v-3l4-2 2 2 6-5 3 1 1-2v3l4 1 1 3 4 1h4v-3h3l2 4 2-2 7 1 2 1 3-1-1-2 5 1h2l2-1v2h4v2l5-2 4-1 4 2 9-2 2 1 2 2v-2l7-1h3l2-3h2l1-2 1 5 5-1h2l1-4 2-1 5 3 3-1v-2l10-2 2-5v-1l8-1 5 2z"
      fill="#DC2A5E"
    />
    <path
      transform="translate(955,2033)"
      d="m0 0 2 1v2h10l2-2 5 1 4-1 9 3 1-4 3 1v2h4v-2l9 2h26l5 1h14l7 1 4-1 1 1h25l6 1 1-2 15-1 4-1 1 4-5-1 1 6 3 1-32 3h-112l-21-2 3-1-2-6 2-4v2h2v-2h2z"
      fill="#DC2A5E"
    />
    <path
      transform="translate(1233,1499)"
      d="m0 0h1v81l1 6-1 20v27l1 7v7l-222 1-26-1 3-3h9l2-1 8-1 4 1 4-1 9 1 3-1 4 1 4-1 9 1h33l4-1 5 1h27l1-2 1 2 5-1 3-2 8 3v-2l8 1 5-2 5 3h20l1 1h21l9 1 8-1 10 1 9-4 2-3-4-5v-3-2h-5v-8l-1-3 1-3h2l-1-3 4-5-1-5 1-5v-3l1-5-2-5 2-3-1-8 1-5 1-7v-5l2-5-1-8v-7h2v-2h-2l2-10v-12z"
      fill="#DC2A5E"
    />
    <path
      transform="translate(476,1566)"
      d="m0 0h7l4 2v-2l5 1 3 1v-2h4v2l16-2 4 1 11-1 7 1h53l13-1h4l10 1 2 1 1-2 7 3v-3l4 1v2h3l2-3 5 1h2 6l1 3 7 1 10 1 9-1h14v2l3 1-12 1h-238l1-2h3l1-2 3 1h7l4-3 5-1 2-1v2l4-1z"
      fill="#DC2A5E"
    />
    <path
      transform="translate(1019,1240)"
      d="m0 0 4 1-8 10-14 19-14 18-21 28-10 13-4 4 1-5-1-3 1-2h2l2-6 3-2 2-5 1-5 4-2-1-2h2l1-4 3-1-1-2 5-1-1-4 3-5 4-5 2-1 1-5 2-2 6-7 3-4 2-8 6-7z"
      fill="#F27341"
    />
    <path
      transform="translate(813,1185)"
      d="m0 0 5 5 3 4h-2v2l2 1-1 2h2v2l3 1 3 3 3 7-3 1-2 5-2 1-1 3-12 5-2 1-5-3-1 2-3-1 2-5 1-2 1-3h-3v-2h2l2-8h-2l-1-5z"
      fill="#F27341"
    />
    <path
      transform="translate(1220,1626)"
      d="m0 0 7 2 2 4v3l3 3-4 5-8 3-14-1-6 1-13-1h-16l-1-1h-21l-3-3v-2l4-1 3-1 6 1 4-1 1 2 4-2h3v2l8-3 2 2h4v-2h2v2l6-2h13l3-3h3l1-3 6-3z"
      fill="#E34356"
    />
    <path
      transform="translate(1010,1203)"
      d="m0 0h2l1 2 6-2-1 3h-2l-1 3-18 6-21 4-8 1h-22l-6-2 1-3-2-1v-2l-3-1-1-4h9l1 1h32l6-1 6 2-1 2 2 1 1-4 6-3 7-1 1 1h3 2z"
      fill="#E54853"
    />
    <path
      transform="translate(405,1478)"
      d="m0 0 2 4v86h2l1 30-5 1v-2h-2l-1-9-2-1-1-6 2-4-2-1 1-6v-10l2-3-1-3h2l-2-8 1-6v-7-4l1-7-1-4 2-6h-2l1-8 1-4z"
      fill="#DC2B5E"
    />
    <path
      transform="translate(442,1335)"
      d="m0 0h1l1 156v72l-1 7-2-3v-122z"
      fill="#DC2A5E"
    />
    <path
      transform="translate(1235,1406)"
      d="m0 0h1v180l-2-4-1-4v-34l1-46z"
      fill="#E9564E"
    />
    <path
      transform="translate(824,1227)"
      d="m0 0 4 1 3 4 8 2-4 2-5 1-3-1h-12l-1 2-6 1-1 3-5 1-2 4-4 1 2-1 1-6h2l2-4 1-3h3l1-3h2l3-3h4v3l6-1-1-2z"
      fill="#F27341"
    />
    <path
      transform="translate(1010,1203)"
      d="m0 0h2l1 2 6-2-1 3h-2l-1 3-18 6-5-1-1-6 6-3 7-1 1 1h3 2z"
      fill="#E64B52"
    />
    <path
      transform="translate(1396,1952)"
      d="m0 0 1 2 3-1-2 8h-2v2l4 1v2l-10-3-1 4-6 3v-2l-4 2-3-4h2v-2h6l1-4h3v-2h3l1-2 3-1z"
      fill="#DB275F"
    />
    <path
      transform="translate(706,1566)"
      d="m0 0h1l1 9-2 1h-81v-1l56-1 12-1 3-1 1-3 1 2h6z"
      fill="#E8534E"
    />
    <path
      transform="translate(702,1241)"
      d="m0 0h2l-1 6-5 1v-2h-2l-1 2h-5l-3 3-9 1-3 2-1 2-6-2-1-2 7-2 3-3 4-1v2h6v-2h5v-2h5l4-1z"
      fill="#E44456"
    />
    <path
      transform="translate(685,1210)"
      d="m0 0h4v5l-3 4-5 2-6 6-6-1 2-4h4l1-5 3-2 1-4 3 1z"
      fill="#E44455"
    />
    <path
      transform="translate(314,1734)"
      d="m0 0 5 3-1 2v1l1 4 6 2v3l-7-3-1 2-3-1-1-2h-3l-2-4-3-3 4-2z"
      fill="#E13A59"
    />
    <path
      transform="translate(996,1255)"
      d="m0 0 3 1h-2v5l-5 5-5 7-2 1-3 7-10 9v-3l16-21z"
      fill="#E9544E"
    />
    <path
      transform="translate(1978,1221)"
      d="m0 0 2 3v2l-7 4h-2v2l-6 3h-2v-8l6-5v3l7-1z"
      fill="#E44455"
    />
    <path
      transform="translate(1263,1676)"
      d="m0 0 1 2-2 4-1 3h-4l-1 3-4-2h-3-4v-3l-3-1 15-2 3-1z"
      fill="#DC2A5F"
    />
    <path
      transform="translate(970,1598)"
      d="m0 0 2 3 1 27-2 9h-1z"
      fill="#DC2A5F"
    />
    <path
      transform="translate(723,1241)"
      d="m0 0 2 1-1 5h2l2-4 1 5-3 6-3 3v-3l-2-1 1-2-3-1 1-2h3v-2l-3-1 3-1z"
      fill="#E54A53"
    />
    <path
      transform="translate(704,1538)"
      d="m0 0 2 2v4h-2v16l-2 3-2-1 1-5-1-5 3-12z"
      fill="#DC2A5F"
    />
    <path
      transform="translate(819,1194)"
      d="m0 0 4 1 10 9-4 1-4-1-3-3v-2h-2z"
      fill="#E9554E"
    />
    <path
      transform="translate(592,1253)"
      d="m0 0h9l5 1v1h-7v2h-24l1-2h16z"
      fill="#F37441"
    />
    <path
      transform="translate(1010,1203)"
      d="m0 0h2l1 2 6-2-1 3h-2l-1 3-8 3-4-1 3-2 2-1v-3h2z"
      fill="#F17042"
    />
    <path
      transform="translate(337,1656)"
      d="m0 0h4l1 2 2 1-4 5-4 3-2-1 1-1-2-2 3-1z"
      fill="#E34156"
    />
    <path
      transform="translate(353,1797)"
      d="m0 0 5 1 7 4 2 5h2l1 4-4-2-11-10z"
      fill="#E54A58"
    />
    <path
      transform="translate(1167,1588)"
      d="m0 0 4 2v5l2-3 6 2-3 3-6-1-4-3z"
      fill="#DC2A5E"
    />
    <path
      transform="translate(983,1275)"
      d="m0 0 1 3-7 8-6 4 2-4 6-8z"
      fill="#E74F50"
    />
    <path
      transform="translate(325,1749)"
      d="m0 0 6 2v-2h2l2 3v5l-3 1-4-5-3-3z"
      fill="#E44456"
    />
    <path
      transform="translate(913,2034)"
      d="m0 0 6 1v2h-3v2l2 1h-2v2h-6v-3l3-1-1-3z"
      fill="#DC2C5D"
    />
    <path
      transform="translate(946,1980)"
      d="m0 0 1 2 3-1 4 8-3 1v-2l-4 1 1-4h-3z"
      fill="#D82261"
    />
    <path
      transform="translate(542,1156)"
      d="m0 0 2 1v4l-3 1-1 3-3 1v-6z"
      fill="#E74E51"
    />
    <path
      transform="translate(741,1978)"
      d="m0 0h5v5l-6 1-1-3-2-1z"
      fill="#D61B63"
    />
    <path
      transform="translate(1555,1232)"
      d="m0 0 4 1-9 12v-3l3-7z"
      fill="#F27241"
    />
    <path
      transform="translate(2011,1294)"
      d="m0 0 1 2-3 11h-2v-10h2v-2z"
      fill="#F37846"
    />
    <path
      transform="translate(1400,1182)"
      d="m0 0 5 1-1 3-3 3h-5l2-5 2-1z"
      fill="#E44555"
    />
    <path
      transform="translate(28,1261)"
      d="m0 0h3v4l2 1-1 5-2 2-2-7z"
      fill="#F27647"
    />
    <path
      transform="translate(2014,1194)"
      d="m0 0h2l3 5-2 4-4-3z"
      fill="#E44456"
    />
    <path
      transform="translate(1326,1217)"
      d="m0 0 2 1-1 5h-2v2h-2l-1 3-2-2 1-4z"
      fill="#E44456"
    />
    <path
      transform="translate(1144,1223)"
      d="m0 0 3 1v2 3l-3 1v-2l-4-1z"
      fill="#E64A53"
    />
    <path
      transform="translate(376,1816)"
      d="m0 0 6 1 2 2 3 4-1 2-10-8z"
      fill="#E54C5B"
    />
    <path
      transform="translate(360,1610)"
      d="m0 0 2 2-4 5h-2v-2h-2l2-4z"
      fill="#E44456"
    />
    <path
      transform="translate(974,1643)"
      d="m0 0 8 1v2l-3 1h-7v-2h2z"
      fill="#DC2A5F"
    />
    <path
      transform="translate(906,2035)"
      d="m0 0 7 1 1 3-3 2-3-1-2-1z"
      fill="#D61B63"
    />
    <path
      transform="translate(400,1832)"
      d="m0 0 1 2 4 1 2 6-6-4-3-3h2z"
      fill="#E64E5A"
    />
    <path
      transform="translate(1052,1627)"
      d="m0 0 5 2 2 3h-2v2l-3-1v-2h-2z"
      fill="#E44456"
    />
    <path
      transform="translate(1032,1628)"
      d="m0 0 4 1v4l-5 2-1-2h2l-1-4z"
      fill="#E34256"
    />
    <path
      transform="translate(1566,1210)"
      d="m0 0 2 1-2 6-5 3 1-5 2-1v-2h2z"
      fill="#E44555"
    />
    <path
      transform="translate(1010,1203)"
      d="m0 0h2l1 2 6-2-1 3h-2l-2 2-5-1-1-2h2z"
      fill="#E44555"
    />
    <path
      transform="translate(819,1137)"
      d="m0 0h2l6 12-3-1-5-8z"
      fill="#E85050"
    />
  </svg>
);
export default XPD;
